import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { VesselService, NotificationService } from '@services';
import { catchError, of } from 'rxjs';

import { VesselEntry } from '@models';

export const vesselResolver: ResolveFn<VesselEntry | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const vesselService = inject(VesselService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const vesselId = route.paramMap.get('id');
  if (!vesselId) {
    return of(null);
  }

  return vesselService.getVessel(vesselId).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          });
          notificationService.error('Failed to load the requested vessel.');
          break;
      }

      return of(null);
    }),
  );
};
